
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/promocoes/nova-oferta",
      function () {
        return require("private-next-pages/promocoes/nova-oferta.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/promocoes/nova-oferta"])
      });
    }
  